const data = [
  {
    lv: 1,
    exp: 0,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/1.png",
    },
    rank: "D",
  },
  {
    lv: 2,
    exp: 20,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/1.png",
    },
    rank: "D",
  },
  {
    lv: 3,
    exp: 40,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/1.png",
    },
    rank: "D",
  },
  {
    lv: 4,
    exp: 60,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/1.png",
    },
    rank: "D",
  },
  {
    lv: 5,
    exp: 8000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/1.png",
    },
    rank: "D",
  },
  {
    lv: 6,
    exp: 10000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/1.png",
    },
    rank: "D",
  },
  {
    lv: 7,
    exp: 12000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/1.png",
    },
    rank: "D",
  },
  {
    lv: 8,
    exp: 14000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/1.png",
    },
    rank: "D",
  },
  {
    lv: 9,
    exp: 16000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/1.png",
    },
    rank: "D",
  },
  {
    lv: 10,
    exp: 18000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/10.png",
    },
    rank: "D",
  },
  {
    lv: 11,
    exp: 20000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/10.png",
    },
    rank: "D",
  },
  {
    lv: 12,
    exp: 22000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/10.png",
    },
    rank: "D",
  },
  {
    lv: 13,
    exp: 24000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/10.png",
    },
    rank: "D",
  },
  {
    lv: 14,
    exp: 26000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/10.png",
    },
    rank: "D",
  },
  {
    lv: 15,
    exp: 28000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/10.png",
    },
    rank: "D",
  },
  {
    lv: 16,
    exp: 30000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/10.png",
    },
    rank: "D",
  },
  {
    lv: 17,
    exp: 32000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/10.png",
    },
    rank: "D",
  },
  {
    lv: 18,
    exp: 34000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/10.png",
    },
    rank: "D",
  },
  {
    lv: 19,
    exp: 36000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/10.png",
    },
    rank: "D",
  },
  {
    lv: 20,
    exp: 38000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/20.png",
    },
    rank: "D",
  },
  {
    lv: 21,
    exp: 40000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/20.png",
    },
    rank: "D",
  },
  {
    lv: 22,
    exp: 42000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/20.png",
    },
    rank: "D",
  },
  {
    lv: 23,
    exp: 44000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/20.png",
    },
    rank: "D",
  },
  {
    lv: 24,
    exp: 46000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/20.png",
    },
    rank: "D",
  },
  {
    lv: 25,
    exp: 48000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/20.png",
    },
    rank: "D",
  },
  {
    lv: 26,
    exp: 50000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/20.png",
    },
    rank: "D",
  },
  {
    lv: 27,
    exp: 52000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/20.png",
    },
    rank: "D",
  },
  {
    lv: 28,
    exp: 54000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/20.png",
    },
    rank: "D",
  },
  {
    lv: 29,
    exp: 56000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/20.png",
    },
    rank: "D",
  },
  {
    lv: 30,
    exp: 58000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/20.png",
    },
    rank: "D",
  },
  {
    lv: 31,
    exp: 60000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/30.png",
    },
    rank: "D",
  },
  {
    lv: 32,
    exp: 62000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/30.png",
    },
    rank: "D",
  },
  {
    lv: 33,
    exp: 64000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/30.png",
    },
    rank: "D",
  },
  {
    lv: 34,
    exp: 66000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/30.png",
    },
    rank: "D",
  },
  {
    lv: 35,
    exp: 68000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/30.png",
    },
    rank: "D",
  },
  {
    lv: 36,
    exp: 70000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/30.png",
    },
    rank: "D",
  },
  {
    lv: 37,
    exp: 72000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/30.png",
    },
    rank: "D",
  },
  {
    lv: 38,
    exp: 74000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/30.png",
    },
    rank: "D",
  },
  {
    lv: 39,
    exp: 76000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/30.png",
    },
    rank: "D",
  },
  {
    lv: 40,
    exp: 78000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/40.png",
    },
    rank: "D",
  },
  {
    lv: 41,
    exp: 80000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/40.png",
    },
    rank: "D",
  },
  {
    lv: 42,
    exp: 82000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/40.png",
    },
    rank: "D",
  },
  {
    lv: 43,
    exp: 84000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/40.png",
    },
    rank: "D",
  },
  {
    lv: 44,
    exp: 86000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/40.png",
    },
    rank: "D",
  },
  {
    lv: 45,
    exp: 88000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/40.png",
    },
    rank: "D",
  },
  {
    lv: 46,
    exp: 90000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/40.png",
    },
    rank: "D",
  },
  {
    lv: 47,
    exp: 92000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/40.png",
    },
    rank: "D",
  },
  {
    lv: 48,
    exp: 94000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/40.png",
    },
    rank: "D",
  },
  {
    lv: 49,
    exp: 96000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/40.png",
    },
    rank: "D",
  },
  {
    lv: 50,
    exp: 98000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/40.png",
    },
    rank: "D",
  },
  {
    lv: 51,
    exp: 100000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/50.png",
    },
    rank: "D",
  },
  {
    lv: 52,
    exp: 102000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/50.png",
    },
    rank: "D",
  },
  {
    lv: 53,
    exp: 104000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/50.png",
    },
    rank: "D",
  },
  {
    lv: 54,
    exp: 106000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/50.png",
    },
    rank: "D",
  },
  {
    lv: 55,
    exp: 108000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/50.png",
    },
    rank: "D",
  },
  {
    lv: 56,
    exp: 110000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/50.png",
    },
    rank: "D",
  },
  {
    lv: 57,
    exp: 112000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/50.png",
    },
    rank: "D",
  },
  {
    lv: 58,
    exp: 114000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/50.png",
    },
    rank: "D",
  },
  {
    lv: 59,
    exp: 116000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/50.png",
    },
    rank: "D",
  },
  {
    lv: 60,
    exp: 118000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/50.png",
    },
    rank: "D",
  },
  {
    lv: 61,
    exp: 118010,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/60.png",
    },
    rank: "C",
  },
  {
    lv: 62,
    exp: 118020,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/60.png",
    },
    rank: "C",
  },
  {
    lv: 63,
    exp: 130000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/60.png",
    },
    rank: "C",
  },
  {
    lv: 64,
    exp: 134000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/60.png",
    },
    rank: "C",
  },
  {
    lv: 65,
    exp: 138000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/60.png",
    },
    rank: "C",
  },
  {
    lv: 66,
    exp: 142000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/60.png",
    },
    rank: "C",
  },
  {
    lv: 67,
    exp: 146000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/60.png",
    },
    rank: "C",
  },
  {
    lv: 68,
    exp: 150000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/60.png",
    },
    rank: "C",
  },
  {
    lv: 69,
    exp: 154000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/60.png",
    },
    rank: "C",
  },
  {
    lv: 70,
    exp: 158000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/70.png",
    },
    rank: "C",
  },
  {
    lv: 71,
    exp: 162000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/70.png",
    },
    rank: "C",
  },
  {
    lv: 72,
    exp: 164000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/70.png",
    },
    rank: "C",
  },
  {
    lv: 73,
    exp: 168000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/70.png",
    },
    rank: "C",
  },
  {
    lv: 74,
    exp: 172000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/70.png",
    },
    rank: "C",
  },
  {
    lv: 75,
    exp: 176000,
    grid: {
      uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/70.png",
    },
    rank: "C",
  },
];

export function autolize_Lv(params) {
  try {
    const result = data
      .filter((item, index) => item.exp <= params)
      .reverse()?.[0];
    // console.log("result", result);
    return { ...result };
  } catch (error) {
    return {
      lv: 1,
      exp: 0,
      grid: {
        uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/1.png",
      },
    };
  }
}

export function nextautolize_Lv(params) {
  try {
    return data.filter((item, index) => item.exp > params)?.[0];
  } catch (error) {
    return {
      lv: 2,
      exp: 20,
      grid: {
        uri: "https://ssr-project.s3.ap-southeast-1.amazonaws.com/rank/1.png",
      },
    };
  }
}
